import { render, staticRenderFns } from "./Exit_relay.vue?vue&type=template&id=dfa8f116"
import script from "./Exit_relay.vue?vue&type=script&lang=js"
export * from "./Exit_relay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports